<template>
  <v-menu open-on-hover offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-badge
          bordered
          bottom
          dot
          color="deep-purple accent-4"
          offset-x="10"
          offset-y="10"
      >
        {{ me.name }}
        <v-avatar size="40" v-bind="attrs" v-on="on">
          <v-icon large>
            mdi-account-circle
          </v-icon>
        </v-avatar>
      </v-badge>
    </template>

    <v-list dense>
      <v-list-item-group v-model="item" color="primary">
        <v-list-item v-for="(item, i) in items" :key="i" link @click="item.click">
          <v-list-item-icon>
            <v-icon v-text="item.icon"/>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="$t(item.text)"/>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'Navbar',
  data() {
    return {
      item: 1,
      items: [
        {text: 'label.logout', icon: 'mdi-export', click: this.logout}
      ],
    }
  },
  methods: {
    logout() {
      return this.$store.dispatch('auth/logout')
          .then(() => {
            this.$router.push({ name: 'login' })
          });
    },
  },
  computed: {
    me(){
      return this.$store.getters['auth/user'] || {}
    },
  }
}
</script>